import React from 'react';

const Header = () => {
    return (                 <div className="Header m-5 p-3 me-0 ms-0">
    <i class="fa-brands fa-pagelines fs-2 title"></i>
    <h1  className="title"><i>Chic Chick</i></h1> 
    <h6> Chic Styles for Every Chick</h6>
    </div> );
}
 
export default Header;